import { ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router';
import * as R from '../routes';
import { useClientQuery } from '@/hooks/webapi/client/useClientQuery';

type Props = {
  children: ReactElement;
};

export default function ActiveLoanGuard({ children }: Props) {
  const { data: client } = useClientQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (!client?.hasOpenLoan) navigate(R.REPEATED_LOAN);
  }, [client?.hasOpenLoan]);

  return children;
}
